import { generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmDropdownBox, mmDropdownBoxOptions } from "@/types";
import Collapsible from "./collapsible";

class DropdownBox extends Collapsible<mmDropdownBoxOptions> implements mmDropdownBox {
  private _dxDropDownBox!: DevExpress.ui.dxDropDownBox;

  constructor(element: HTMLElement, options?: mmDropdownBoxOptions) {
    super(element, options);

    const {
      color,
      size,
      shape,
      className,
      attributes,
      style,
      dropDownWidth,
      dropDownMinWidth,
      displayExpr,
      deferRendering,
      onInitialized: userOnInitialized,
      dropDownOptions: userDropDownOptions,
      elementAttr: userElementAttr,
      ...dxOptions
    } = this._options;

    this._dxDropDownBox = ($(this._element) as any)
      .dxDropDownBox({
        ...dxOptions,
        displayExpr,
        deferRendering,
        elementAttr: {
          ...(userElementAttr ?? {}),
          class: generateClassName("dropdown-box", color!, size!, shape, className),
          ...(attributes ?? {}),
        },
        stylingMode: style,
        dropDownOptions: {
          ...userDropDownOptions,
          container: this._element.parentElement ?? "body",
          hideOnParentScroll: false,
          wrapperAttr: {
            class: generateClassName(
              "dropdown-popup",
              color === "default" ? "primary" : color!,
              size!,
            ),
          },
          width: dropDownWidth ?? userDropDownOptions?.width,
          minWidth: dropDownMinWidth ?? userDropDownOptions?.minWidth,
          onShowing: this._onPopupShowing,
          onShown: this._onPopupShown,
          onHiding: this._onPopupHiding,
        },
        dropDownButtonTemplate: this._dropDownButtonTemplate,
        onInitialized: (e: DevExpress.ui.dxDropDownBox.InitializedEvent) => {
          e.element!.on("mousedown", () => {
            if (!this._options.readOnly) {
              e.component!.focus();
            }
          });
          userOnInitialized?.(e);
        },
      })
      .dxDropDownBox("instance");
  }

  public getDefaults(): mmDropdownBoxOptions {
    return {
      color: "default",
      size: "md",
      shape: "normal",
      style: "outlined",
      width: "100%",
      placeholder: "Select...",
      showDropDownButton: true,
      deferRendering: true,
      openOnFieldClick: true,
    };
  }

  private _dropDownButtonTemplate = (): JQuery => {
    return $("<div class='dx-icon dx-icon-spindown'>");
  };

  public get value(): unknown {
    return this._dxDropDownBox.option("value");
  }

  public set value(val: unknown) {
    this._dxDropDownBox.option("value", val);
  }

  public get isOpened(): boolean {
    return this._dxDropDownBox.option("opened") ?? false;
  }

  public open(): void {
    this._dxDropDownBox.open();
  }

  public close(): void {
    this._dxDropDownBox.close();
  }
}

registerComponent("mmDropdownBox", DropdownBox);

export default DropdownBox;
